function getFocusableElements(a) {
    return Array.from(a.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
const trapFocusHandlers = {};
function trapFocus(b, c = b) {
    var a = getFocusableElements(b),
        d = a[0],
        e = a[a.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (a) => {
            (a.target === b || a.target === e || a.target === d) && document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (a) {
            "TAB" === a.code.toUpperCase() && (a.target !== e || a.shiftKey || (a.preventDefault(), d.focus()), (a.target === b || a.target === d) && a.shiftKey && (a.preventDefault(), e.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        c.focus();
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((a) => {
        a.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((a) => {
            a.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((a) => a.pause()),
        document.querySelectorAll("product-model").forEach((a) => a.modelViewerUI?.pause());
}
function removeTrapFocus(a = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), a && a.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
        super(), (this.input = this.querySelector("input")), (this.changeEvent = new Event("change", { bubbles: !0 })), this.querySelectorAll("button").forEach((a) => a.addEventListener("click", this.onButtonClick.bind(this)));
    }
    onButtonClick(a) {
        a.preventDefault();
        let b = this.input.value;
        "plus" === a.target.name ? this.input.stepUp() : this.input.stepDown(), b !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
}
function debounce(a, b) {
    let c;
    return (...d) => {
        clearTimeout(c), (c = setTimeout(() => a.apply(this, d), b));
    };
}
customElements.define("quantity-input", QuantityInput);
const serializeForm = (d) => {
    let a = {},
        b = new FormData(d);
    for (let c of b.keys()) a[c] = b.get(c);
    return JSON.stringify(a);
};
function fetchConfig(a = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${a}` } };
}
void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (a, b) {
        return function () {
            return a.apply(b, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (b, c) {
        for (var a = 0, e = b.options.length; a < e; a++) {
            var d = b.options[a];
            if (c == d.value || c == d.innerHTML) return (b.selectedIndex = a), a;
        }
    }),
    (Shopify.addListener = function (a, b, c) {
        a.addEventListener ? a.addEventListener(b, c, !1) : a.attachEvent("on" + b, c);
    }),
    (Shopify.postLink = function (f, c) {
        var g = (c = c || {}).method || "post",
            d = c.parameters || {},
            a = document.createElement("form");
        for (var e in (a.setAttribute("method", g), a.setAttribute("action", f), d)) {
            var b = document.createElement("input");
            b.setAttribute("type", "hidden"), b.setAttribute("name", e), b.setAttribute("value", d[e]), a.appendChild(b);
        }
        document.body.appendChild(a), a.submit(), document.body.removeChild(a);
    }),
    (Shopify.CountryProvinceSelector = function (b, a, c) {
        (this.countryEl = document.getElementById(b)),
            (this.provinceEl = document.getElementById(a)),
            (this.provinceContainer = document.getElementById(c.hideElement || a)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var a = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, a), this.countryHandler();
        },
        initProvince: function () {
            var a = this.provinceEl.getAttribute("data-default");
            a && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, a);
        },
        countryHandler: function (e) {
            var a = this.countryEl.options[this.countryEl.selectedIndex],
                d = a.getAttribute("data-provinces"),
                b = JSON.parse(d);
            if ((this.clearOptions(this.provinceEl), b && 0 == b.length)) this.provinceContainer.style.display = "none";
            else {
                for (var c = 0; c < b.length; c++) {
                    var a = document.createElement("option");
                    (a.value = b[c][0]), (a.innerHTML = b[c][1]), this.provinceEl.appendChild(a);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (a) {
            for (; a.firstChild; ) a.removeChild(a.firstChild);
        },
        setOptions: function (d, a) {
            for (var b = 0; b < a.length; b++) {
                var c = document.createElement("option");
                (c.value = a[b]), (c.innerHTML = a[b]), d.appendChild(c);
            }
            a.length;
        },
    });
class MenuDrawer extends HTMLElement {
    constructor() {
        super(), (this.mainDetailsToggle = this.querySelector("details"));
        let a = this.querySelectorAll("summary");
        this.addAccessibilityAttributes(a),
            "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`),
            this.addEventListener("keyup", this.onKeyUp.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.bindEvents();
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((a) => a.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button").forEach((a) => a.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }
    addAccessibilityAttributes(a) {
        a.forEach((a) => {
            a.setAttribute("role", "button"), a.setAttribute("aria-expanded", !1), a.nextElementSibling && a.nextElementSibling.id && a.setAttribute("aria-controls", a.nextElementSibling.id);
        });
    }
    onKeyUp(b) {
        if ("ESCAPE" !== b.code.toUpperCase()) return;
        let a = b.target.closest("details[open]");
        a && (a === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(a));
    }
    onSummaryClick(c) {
        let a = c.currentTarget,
            b = a.parentNode,
            d = b.hasAttribute("open");
        b === this.mainDetailsToggle
            ? (d && c.preventDefault(), d ? this.closeMenuDrawer(a) : this.openMenuDrawer(a))
            : (trapFocus(a.nextElementSibling, b.querySelector("button")),
              setTimeout(() => {
                  b.classList.add("menu-opening");
              }));
    }
    openMenuDrawer(a) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        }),
            a.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, a),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
            document.body.classList.add("overflow-cstm-filter");
    }
    closeMenuDrawer(a, b = !1) {
        void 0 !== a &&
            (this.mainDetailsToggle.classList.remove("menu-opening"),
            this.mainDetailsToggle.querySelectorAll("details").forEach((a) => {
                a.removeAttribute("open"), a.classList.remove("menu-opening");
            }),
            this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1),
            document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
             setTimeout(() => {
           document.body.classList.remove("overflow-cstm-filter");
              },550),
            removeTrapFocus(b),
            this.closeAnimation(this.mainDetailsToggle));
    }
    onFocusOut(a) {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(a) {
        let b = a.currentTarget.closest("details");
        this.closeSubmenu(b);
    }
    closeSubmenu(a) {
        a.classList.remove("menu-opening"), removeTrapFocus(), this.closeAnimation(a);
    }
    closeAnimation(b) {
        let c,
            a = (d) => {
                void 0 === c && (c = d), d - c < 400 ? window.requestAnimationFrame(a) : (b.removeAttribute("open"), b.closest("details[open]") && trapFocus(b.closest("details[open]"), b.querySelector("summary")));
            };
        window.requestAnimationFrame(a);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }
    openMenuDrawer(a) {
        (this.header = this.header || document.getElementById("shopify-section-header")),
            (this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0),
            document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`),
            setTimeout(() => {
                this.mainDetailsToggle.classList.add("menu-opening");
            }),
            a.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, a),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
            // document.body.classList.add("overflow-cstm-filter");
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
            this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this)),
            this.addEventListener("click", (a) => {
                "MODAL-DIALOG" === a.target.nodeName && this.hide();
            }),
            this.addEventListener("keyup", (a) => {
                "ESCAPE" === a.code?.toUpperCase() && this.hide();
            });
    }
    show(a) {
        (this.openedBy = a), document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), this.querySelector(".template-popup")?.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]'));
    }
    hide() {
        document.body.classList.remove("overflow-hidden"), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        let a = this.querySelector("button");
        a?.addEventListener("click", () => {
            document.querySelector(this.getAttribute("data-modal"))?.show(a);
        });
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super(), this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener("click", this.loadContent.bind(this));
    }
    loadContent() {
        if (!this.getAttribute("loaded")) {
            let a = document.createElement("div");
            a.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0), window.pauseAllMedia(), this.appendChild(a.querySelector("video, model-viewer, iframe")).focus();
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.slider = this.querySelector("ul")),
            (this.sliderItems = this.querySelectorAll("li")),
            (this.pageCount = this.querySelector(".slider-counter--current")),
            (this.pageTotal = this.querySelector(".slider-counter--total")),
            (this.prevButton = this.querySelector('button[name="previous"]')),
            (this.nextButton = this.querySelector('button[name="next"]')),
            !this.slider || !this.nextButton)
        )
            return;
        let a = new ResizeObserver((a) => this.initPages());
        a.observe(this.slider),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }
    initPages() {
        this.sliderItems.length, (this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth)), (this.totalPages = this.sliderItems.length - this.slidesPerPage + 1), this.update();
    }
    update() {
        this.pageCount &&
            this.pageTotal &&
            ((this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1),
            1 === this.currentPage ? this.prevButton.setAttribute("disabled", !0) : this.prevButton.removeAttribute("disabled"),
            this.currentPage === this.totalPages ? this.nextButton.setAttribute("disabled", !0) : this.nextButton.removeAttribute("disabled"),
            (this.pageCount.textContent = this.currentPage),
            (this.pageTotal.textContent = this.totalPages));
    }
    onButtonClick(a) {
        a.preventDefault();
        let b = "next" === a.currentTarget.name ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
        this.slider.scrollTo({ left: b });
    }
}
customElements.define("slider-component", SliderComponent);
class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", this.onVariantChange);
    }
    onVariantChange() {
        this.updateOptions(),
            this.updateMasterId(),
            this.toggleAddButton(!0, "", !1),
            this.updatePickupAvailability(),
            this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (a) => a.value);
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((a) => !a.options.map((a, b) => this.options[b] === a).includes(!1));
    }
    updateMedia() {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        let a = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if (!a) return;
        let b = a.parentElement;
        b.prepend(a),
            window.setTimeout(() => {
                b.scroll(0, 0);
            });
    }
    updateURL() {
        this.currentVariant && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        let a = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        a.forEach((b) => {
            let a = b.querySelector('input[name="id"]');
            (a.value = this.currentVariant.id), a.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
    updatePickupAvailability() {
        let a = document.querySelector("pickup-availability");
        a && (this.currentVariant?.available ? a.fetchAvailability(this.currentVariant.id) : (a.removeAttribute("available"), (a.innerHTML = "")));
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((a) => a.text())
            .then((d) => {
                let a = `price-${this.dataset.section}`,
                    e = new DOMParser().parseFromString(d, "text/html"),
                    b = document.getElementById(a),
                    c = e.getElementById(a);
                c && b && (b.innerHTML = c.innerHTML), document.getElementById(`price-${this.dataset.section}`)?.classList.remove("visibility-hidden"), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          const bundlesForm = document.querySelector(".bundles_form");
             if(bundlesForm){
                 getBundlesDetails(this.currentVariant);         
             }
            });
    }
    toggleAddButton(c = !0, b, d = !0) {
        let a = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
        if (a && (c ? (a.setAttribute("disabled", !0), b && (a.textContent = b)) : (a.removeAttribute("disabled"), (a.textContent = window.variantStrings.addToCart)), !d)) return;
    }
    setUnavailable() {
        let a = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
        a && ((a.textContent = window.variantStrings.unavailable), document.getElementById(`price-${this.dataset.section}`)?.classList.add("visibility-hidden"));
    }
    getVariantData() {
        return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
    updateOptions() {
        let a = Array.from(this.querySelectorAll("fieldset"));
        this.options = a.map((a) => Array.from(a.querySelectorAll("input")).find((a) => a.checked).value);
    }
}
customElements.define("variant-radios", VariantRadios);

function getBundlesDetails(currVariant){
var price = currVariant.price;
 var variant = currVariant.id;
  console.log(price);
  $(".bundles_metafield option[data-default='true']").attr("data-price",price);
   $(".bundles_metafield option[data-default='true']").attr("value",variant);
setTimeout(function(){
  $(".bundles_metafield").trigger("change");
},100)  ;
  
}